import { render, staticRenderFns } from "./AccordianTwo.vue?vue&type=template&id=19fbc203&"
import script from "./AccordianTwo.vue?vue&type=script&lang=js&"
export * from "./AccordianTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports